export default __webpack_public_path__ + "static/media/9.1dba8c5b.jpg";